import {BrandColors} from "./types";
import {tokens} from "../tokens/tokens";
import {alpha, lighten} from "@mui/material";
import {uckTokens as clientTokens} from "./uck.tokens";

export const uckPalette: BrandColors = {
    primary: {
        main:         clientTokens.colors.navy700, // granat
        dark:         clientTokens.colors.navy800,
        light:        clientTokens.colors.navy600,
        contrastText: clientTokens.colors.white,
    },

    secondary: {
        main:         clientTokens.colors.gray600,
        dark:         clientTokens.colors.gray800,
        light:        clientTokens.colors.gray400,
        contrastText: clientTokens.colors.white,
    },

    link: {
        main:         clientTokens.colors.turquoise500,
        dark:         clientTokens.colors.turquoise700,
        light:        clientTokens.colors.turquoise400,
        contrastText: clientTokens.colors.turquoise500,
    },

    text: {
        primary:     clientTokens.colors.navy700,
        secondary:   clientTokens.colors.gray600,
        disabled:    clientTokens.colors.gray600,
        hint:        clientTokens.colors.gray600,
        inverse:     tokens.colors.white,
        placeholder: clientTokens.colors.gray600,
    },

    background: {
        default:  clientTokens.colors.beige50,
        paper:    clientTokens.colors.white,
        subtle:   clientTokens.colors.beige300,
        overlay:  'rgba(0, 0, 0, 0.5)',
        dropzone: tokens.colors.slate100,
        element:  tokens.colors.slate100,
        input:    tokens.colors.white,
    },

    action: {
        hover:              alpha(clientTokens.colors.navy700, 0.06),
        hoveredBackground:  tokens.colors.navy50,
        selected:           clientTokens.colors.white,
        selectedBackground: clientTokens.colors.beige500,
        focus:              clientTokens.colors.beige500,
        disabled:           clientTokens.colors.white,
        disabledBackground: tokens.colors.navy600,
        delete:             tokens.colors.red500,
        dragDrop:           clientTokens.colors.turquoise700,
        hoveredDropzone:    alpha(tokens.colors.slate200, 0.25),
    },

    layout: {
        main:    clientTokens.colors.beige50,
        sidebar: clientTokens.colors.beige100,
    },

    dividers: {
        light:   tokens.colors.gray200,
        subtle:  tokens.colors.gray300,
        default: tokens.colors.slate200,
        strong:  tokens.colors.gray500,
        focus:   tokens.colors.slate600,
    },

    message: {
        userText:        clientTokens.colors.navy800,
        userBg:          lighten(clientTokens.colors.navy700, 0.92),
        userTextBg:      lighten(clientTokens.colors.navy700, 0.95),
        assistantText:   tokens.colors.navy600,
        assistantBg:     clientTokens.colors.beige50,
        assistantTextBg: clientTokens.colors.beige300,
        thinking:        lighten(clientTokens.colors.gray400, 0.15),
    },
};